import { render } from "./OpenDirectdebitsPage.vue?vue&type=template&id=7a9956e4&scoped=true"
import script from "./OpenDirectdebitsPage.vue?vue&type=script&lang=js"
export * from "./OpenDirectdebitsPage.vue?vue&type=script&lang=js"

import "./OpenDirectdebitsPage.vue?vue&type=style&index=0&id=7a9956e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9956e4"]])

export default __exports__